export default __webpack_public_path__ + "static/media/about.5de6313f.webp";